import React from 'react'
import AddFilter from '../../../../Components/Filters/AddFilter'

export default function AddGovFilter() {
  return (
    <AddFilter department="gov"/>
  )
}
